import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { personInitialState } from 'v3/data/store/person/state';
import { IPersonalInformation } from 'v3/data/store/person/types';

export const personSlice = createSlice({
  name: 'person',
  initialState: personInitialState,
  reducers: {
    setPersonalInformation: (state, action: PayloadAction<IPersonalInformation>) => {
      state.person = action.payload;
      return state;
    },
    setHasDimoAccount: (state, action: PayloadAction<boolean>) => {
      state.hasDimoAccount = action.payload;
      return state;
    },
  },
});
